import { Component, OnInit } from '@angular/core';
// import { SiAuthenticationService } from '@strategic-insights/ng-authentication';
import { AppService } from './app.service';
declare let $: any;

@Component({
  selector: 'si-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  toastId: string;
  toastIconConfig: object;
  toastContent: string = '';
  showToast: boolean = false;
  blockApplication: boolean = false;
  applicationLoader: boolean;

  constructor(private appService: AppService) {
    this.appService.appBlocker.subscribe((value) => {
      if (value) {
        this.blockApplication = true;
      } else {
        this.blockApplication = false;
      }
    });

    this.appService.appLoader.subscribe((value) => {
      if (value) {
        this.applicationLoader = true;
      } else {
        this.applicationLoader = false;
      }
    });
  }

  ngOnInit() {
    this.appService.tokenExpireStatus.subscribe((value) => {
      if (value) {
        this.toastId = "logoutWarning";
        this.showToast = true;
        this.toastIconConfig = {
          icon: '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>',
          bgIcon: "bg-danger",
          iconColor: "#fbccc2",
        };
        this.toastContent = "Your session has expired.";
      }
    });
    // To keep only one backdrop
    $(document).on("show.bs.modal", ".modal", function () {
      if ($(".modal-backdrop").length > 1) {
        $(".modal-backdrop").not(":first").remove();
      }
    });
    // Remove all backdrop on close
    $(document).on("hide.bs.modal", ".modal", function () {
      if ($(".modal-backdrop").length > 1) {
        $(".modal-backdrop").remove();
      }
    });
  }
}
